'use client'

import { useEffect, useState, useTransition } from 'react'
import { useRouter } from 'next/navigation'
import classNames from 'classnames'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Spinner } from '@dustin-web/microsite-components/src/spinner'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@dustin-web/microsite-components/src/modal-dialog'

type Props = {
  show: boolean
  onClose: () => void
  changedVariantNames: string[]
  confirmUrl: string
}

const ProductVariantModal = ({ show, onClose, changedVariantNames, confirmUrl }: Props) => {
  const router = useRouter()
  const { translate } = useTranslations()
  const [isPending, startTransition] = useTransition()
  const [navigating, setNavigating] = useState(false)

  useEffect(() => {
    if (navigating && !isPending) {
      setNavigating(false)
      onClose()
    }
  }, [isPending, navigating, onClose])

  const handleConfirm = () => {
    setNavigating(true)
    startTransition(() => {
      router.push(confirmUrl, { scroll: false })
    })
  }

  return (
    <ModalDialog show={show} handleClose={onClose}>
      <ModalDialogHeader className="u-mr-16" title={translate('Product_Variant_Modal_Title')} />
      <ModalDialogContent>
        <ul className="u-mb-0 u-py-0">
          {changedVariantNames.map((name, i) => (
            <li
              className={classNames('u-fs-14', { 'u-mb-0': changedVariantNames.length === i + 1 })}
              key={i}>
              {name}
            </li>
          ))}
        </ul>
      </ModalDialogContent>
      <ModalDialogFooter className="u-pt-0">
        <div className="d-flex u-w-100">
          <button
            type="button"
            className="c-btn c-btn--block u-mb-0 u-mr-16"
            onClick={onClose}
            disabled={isPending}>
            {translate('Cancel')}
          </button>
          <button
            type="button"
            className="c-btn c-btn--primary c-btn--block u-mb-0 u-relative"
            onClick={handleConfirm}
            disabled={isPending}>
            {isPending && <Spinner local size="xxs" />}
            {!isPending && translate('Product_Variant_Modal_Continue_Button')}
          </button>
        </div>
      </ModalDialogFooter>
    </ModalDialog>
  )
}

export default ProductVariantModal
